
import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ArrayArticles from "../components/arrayArticles"
import HeadImage from "../components/headImage"

import yaml from "../data/pages/articles.data.yml"

const Article = ({ data }) => {
  return (
    <Layout>
      <SEO title={yaml.title} description={yaml.desc}/>
      <HeadImage fluid={data.file.childImageSharp.fluid} />
      <h2 className="mt-8">{yaml.title}</h2>
      <ArrayArticles className="mt-4" posts={data.allMarkdownRemark} />
    </Layout>
  )
}

export default Article

export const pageQuery = graphql`
query {
  allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          date(formatString: "DD MMMM YYYY", locale: "fr-FR")
          title
          description
          categorie
          featuredImage  {
            childImageSharp {
              fluid(maxWidth: 630) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        excerpt(
          format: PLAIN
          pruneLength: 200
          truncate: true
        )
      }
    }
  }
  file(relativePath: {eq: "headImage-2.png"}) {
    childImageSharp {
      fluid(quality:90, maxWidth: 1280) {
        ...GatsbyImageSharpFluid_tracedSVG
      }
    }
  }
}
`